const DB_NAME = "erp_offline_db";
const DB_VERSION = 1;
const STORE_NAME = "kv";

let dbPromise = null;

const isBrowser = () => typeof window !== "undefined" && typeof indexedDB !== "undefined";

const openDatabase = () => {
  if (!isBrowser()) return Promise.resolve(null);
  if (dbPromise) return dbPromise;

  dbPromise = new Promise((resolve, reject) => {
    const request = indexedDB.open(DB_NAME, DB_VERSION);

    request.onupgradeneeded = () => {
      const db = request.result;
      if (!db.objectStoreNames.contains(STORE_NAME)) {
        db.createObjectStore(STORE_NAME, { keyPath: "key" });
      }
    };

    request.onsuccess = () => resolve(request.result);
    request.onerror = () => reject(request.error);
  });

  return dbPromise;
};

const runTx = async (mode, handler) => {
  const db = await openDatabase();
  if (!db) return null;

  return new Promise((resolve, reject) => {
    const tx = db.transaction(STORE_NAME, mode);
    const store = tx.objectStore(STORE_NAME);
    Promise.resolve(handler(store, tx))
      .then((result) => {
        tx.oncomplete = () => resolve(result);
        tx.onerror = () => reject(tx.error);
        tx.onabort = () => reject(tx.error);
      })
      .catch(reject);
  });
};

const getOfflineValue = async (key, fallback = null) => {
  try {
    const record = await runTx("readonly", (store) => {
      return new Promise((resolve, reject) => {
        const request = store.get(key);
        request.onsuccess = () => resolve(request.result || null);
        request.onerror = () => reject(request.error);
      });
    });
    return record?.value ?? fallback;
  } catch (_error) {
    return fallback;
  }
};

const setOfflineValue = async (key, value) => {
  try {
    await runTx("readwrite", (store) => {
      return new Promise((resolve, reject) => {
        const request = store.put({
          key,
          value,
          updatedAt: new Date().toISOString(),
        });
        request.onsuccess = () => resolve(true);
        request.onerror = () => reject(request.error);
      });
    });
    return value;
  } catch (_error) {
    return value;
  }
};

const removeOfflineValue = async (key) => {
  try {
    await runTx("readwrite", (store) => {
      return new Promise((resolve, reject) => {
        const request = store.delete(key);
        request.onsuccess = () => resolve(true);
        request.onerror = () => reject(request.error);
      });
    });
    return true;
  } catch (_error) {
    return false;
  }
};

export { getOfflineValue, setOfflineValue, removeOfflineValue, DB_NAME, STORE_NAME };
